import { render, staticRenderFns } from "./ReleaseSearch.vue?vue&type=template&id=58a7066f&scoped=true&"
import script from "./ReleaseSearch.vue?vue&type=script&lang=ts&"
export * from "./ReleaseSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ReleaseSearch.vue?vue&type=style&index=0&id=58a7066f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7066f",
  null
  
)

export default component.exports